// src/lib/workTypes.js — the work we are engaged for, per the signed EL
// (the master source). Top level in mandates.work_type, sub-types in
// mandates.work_subtype (migrations/036, 069). Confirmed by Emily 9/18.
import { useLocation } from 'react-router-dom'
export const WORK_TYPE_TREE = [
  { type: 'Financial Advisory', subtypes: ['Direct Capital Raising & Placement', 'M&A'] },
  { type: 'Strategic Advisory', subtypes: ['General Advice', 'Business Development / Client Acquisition'] },
]

export const WORK_TYPES = WORK_TYPE_TREE.map(w => w.type)

// What partners see (Matt, 11/3): "Strategic Business Development" in the
// portal. The data, the CRM and RGA keep "Strategic Advisory", the EL's term.
const PARTNER_WORK_TYPE_LABEL = { 'Strategic Advisory': 'Strategic Business Development' }
export const workTypeLabel = (type, partner) => (partner && PARTNER_WORK_TYPE_LABEL[type]) || type

// True on portal pages, for components the CRM and the portal share.
export const useIsPortal = () => useLocation().pathname.startsWith('/portal')

// [{ type, subtypes: [...] }] for what a mandate carries, in tree order.
export function workTypeChains(workType, workSubtype) {
  const types = workType ?? []
  const subs = workSubtype ?? []
  return WORK_TYPE_TREE
    .filter(w => types.includes(w.type) || w.subtypes.some(s => subs.includes(s)))
    .map(w => ({ type: w.type, subtypes: w.subtypes.filter(s => subs.includes(s)) }))
}
